import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE, EDIT } from "const"
import { LifecycleConnection, LifecycleConnectionCreate } from "server/models"
import {
    StateType,
    hasAccess,
    hasProjectAccess,
    hasLifecycleAccess,
} from "client/utils"
import {
    PRM_LIFECYCLE,
    PRM_LIFECYCLE_PHASE_LIST,
    StoreType,

    IsOwnerLifecycle,
    IsResponsibleLifecycle,
    UpdateLifecycleConnection,

    setLifecycleConnectionConfirmDelete,
    setLifecycleModelReload,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    LabelButton,
    Delimiter,
    Button,
    SpinnerIcon,
    CheckButton,
} from "client/components"


interface EditLifecycleConnectionProps {
    connection: LifecycleConnection
}

let isMounted: boolean

const Form = ({
    connection,
}: EditLifecycleConnectionProps) => {
    const lifecycle = useSelector((state: StoreType) => state.lifecycle.lifecycleView)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [doubleEnd, setDoubleEnd] = useState(connection.doubleEnd)
    const [orthogonal, setOrthogonal] = useState(connection.orthogonal)
    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onSave = () => {
        setSaveState(PENDING)

        const newConnectionData: LifecycleConnectionCreate = {
            id: connection.id,
            lifecycleId: connection.lifecycleId,
            phaseId: connection.phaseId,
            startPhaseId: connection.startPhaseId,
            endPhaseId: connection.endPhaseId,
            startPhaseSide: connection.startPhaseSide,
            endPhaseSide: connection.endPhaseSide,
            points: connection.points,
            doubleEnd,
            orthogonal,
        }

        UpdateLifecycleConnection(newConnectionData).then(() => {
            if (isMounted) {
                setSaveState(IDLE)
            }

            dispatch(setLifecycleModelReload(false))
            setTimeout(() => {
                dispatch(setLifecycleModelReload(true))
            }, 0)
        })
    }

    const onDelete = () => {
        dispatch(setLifecycleConnectionConfirmDelete(connection))
    }


    const editAccess = !project.id
        ? hasAccess(PRM_LIFECYCLE, EDIT)
        : hasProjectAccess(PRM_LIFECYCLE, EDIT)

    const phaseListEditAccess = hasLifecycleAccess(PRM_LIFECYCLE_PHASE_LIST, EDIT)
    const isOwner = IsOwnerLifecycle(project.id, lifecycle, userData)
    const isResponsible = IsResponsibleLifecycle(lifecycle, userData)
    const isProjectResponsible = project.id && isResponsible

    const allowedToEditPhaseList = editAccess || isOwner || isProjectResponsible || phaseListEditAccess

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>
                            {lang.inspector}
                            {
                                allowedToEditPhaseList
                                && <LabelButton onClick={onDelete}>{lang.delete}</LabelButton>
                            }
                        </Label>
                    </FormGroup>
                    <Delimiter size="sm" />

                    <FormGroup>
                        <CheckButton
                            checked={doubleEnd}
                            onChange={() => setDoubleEnd(!doubleEnd)}
                            title={lang.doubleEnd}
                            readOnly={!allowedToEditPhaseList}
                        />
                    </FormGroup>

                    <FormGroup>
                        <CheckButton
                            checked={orthogonal}
                            onChange={() => setOrthogonal(!orthogonal)}
                            title={lang.orthogonal}
                            readOnly={!allowedToEditPhaseList}
                        />
                    </FormGroup>

                    {
                        allowedToEditPhaseList && (
                            <Button variant="success" row onClick={() => onSave()}>
                                {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                            </Button>
                        )
                    }
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
